<template>
  <v-btn @click="onClick" x-small style="">
    {{ paused ? 'Enable Referrals' : 'Pause Referrals' }}
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'
import proMixin from '../proMixin'

export default {
  name: 'PauseButton',
  
  mixins: [ proMixin ],

  props: ['pro'],

  computed: {
    paused() {
      return this.isPaused(this.pro)
    },
  },

  methods: {
    ...mapActions('pros', ['toggleCurrentPause']),

    onClick() {
      this.toggleCurrentPause()
    }
  }
}
</script>